import styled from 'styled-components';

export interface YlabelStyledProps {
  $color: string;
  $fontSize: number;
}

export const YlabelStyled = styled.div<YlabelStyledProps>`
  color: ${({ $color }) => $color};
  font-size: ${({ $fontSize }) => $fontSize}px;
`;
